module.exports = __webpack_public_path__ + "static/media/p1s.dbb727f0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p1s.webp
// module id = 259
// module chunks = 0